import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {ROUTE_PATHS} from '@di-shared/routes';
import React from 'react';

interface MileagePageProps {
  vin: string;
}

function MileagePage({vin}: MileagePageProps) {
  const location = useLocation();
  if (location.pathname === ROUTE_PATHS.MILEAGE.getFullPath(vin)) {
    return (
      <Navigate
        replace
        to={ROUTE_PATHS.MILEAGE_ECO.getFullPath(vin)}
      />
    );
  }
  return <Outlet />;
}

export default MileagePage;
